import api from './Api';

const updateItems = async (data: any) => {
	const paymentData = await api.post('/sales/uSubcriptionItems', data);
	return paymentData;
};

export { updateItems };
